<template>
  <!-- <div class="break">이 영역은 미리보기에서만 제공됩니다</div> -->
  <div class="break" :style="{height: height}">
    <span class="label">{{locale.height}}</span>
    <span
      v-for="height in 5"
      :key="height"
      class="setHeight">
      <input
        type="radio"
        :name="`height_${id}_${item.columnId}`"
        :id="`height_${id}_${item.columnId}_${height - 1}`"
        :value="height - 1" class="input"
        v-model="item.height"
        @change="changeHeight">
      <label :for="`height_${id}_${item.columnId}_${height - 1}`">{{height - 1}}</label>
    </span>
    <p v-if="message" class="sysMessage">{{locale.provide_min_height}}</p>
  </div>
</template>

<script>
export default {
  name: 'BreakModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting'
  ],
  computed: {
    height () {
      const height = Number(this.item.height) * 15
      return `${height}px`
    }
  },
  mounted () {
    this.message = true
    setTimeout(() => {
      this.message = false
    }, 2000)
  },
  data () {
    return {
      message: false
    }
  },
  methods: {
    changeHeight () {
      if (Number(this.item.height) < 3) {
        this.toggleMessage()
      }
    },
    toggleMessage () {
      this.message = true
      setTimeout(() => {
        this.message = false
      }, 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.break {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  vertical-align: center;
}
.label {
  display: inline-block;
  margin: 0 0.5em;
  padding: 0.3em 0.8em;
  border-radius: 2px;
  vertical-align: middle;
  color: $color-white;
  background-color: $color-grey;
}
.setHeight {
  display: inline-block;
  margin: 2px;
  vertical-align: middle;
  label {
    display: block;
    width: 30px;
    padding: 0.3em 0;
    text-align: center;
    color: $color-white;
    border-radius: 2px;
    background-color: $color-lgrey;
    cursor: pointer;
  }
  :checked + label {
    background-color: $color-dark;
  }
}
</style>
